










































import { Prop, Vue } from 'vue-property-decorator';
import { Component, Mixin, Mixins } from 'vue-mixin-decorator';
import { GithubUser } from '@/models/github-user';
import { vxm } from '@/store';

@Component
export default class NavBar extends Vue {
  private isMobileMenuActive = false;

  public navLinkClicked(targetName: string) {
    const target = document.getElementById(targetName);
    const navbar = document.getElementsByClassName('navbar-brand')[0];
    let scrollHeight = 0;
    if (target) {
      scrollHeight += target.offsetTop;
    }

    if (navbar) {
      scrollHeight -= navbar.clientHeight;
    }

    const supportsNativeSmoothScroll =
      'scrollBehavior' in document.documentElement.style;
    if (supportsNativeSmoothScroll) {
      window.scrollTo({ left: 0, top: scrollHeight, behavior: 'smooth' });
    } else {
      window.scrollTo(0, scrollHeight);
    }

    if (this.isMobileMenuActive) {
      this.toggleMobileMenu();
    }
  }

  private toggleMobileMenu(): void {
    this.isMobileMenuActive = !this.isMobileMenuActive;
  }

  private get avatar() {
    return vxm.user.gitUser.avatar_url;
  }

  private get name() {
    return vxm.user.gitUser.name;
  }

  private get sections() {
    return vxm.repo.sections;
  }

  private get Socials() {
    return vxm.config.cfg.social;
  }

  private createFontImport(name: string) {
    return ['fab', name];
  }
}
